export default {
    LOAD_INVENTORY(state, inventory) {
        state.items = inventory
    }
}